import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { api, get } from "./api";

// Default region based on the S3 URL in common.js (ap-south-1)
const AWS_REGION = process.env.REACT_APP_AWS_REGION || "ap-south-1";
const AWS_ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;

// Only create S3Client if credentials are available
let s3 = null;
if (AWS_ACCESS_KEY_ID && AWS_SECRET_ACCESS_KEY) {
  s3 = new S3Client({
    region: AWS_REGION,
    credentials: {
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
    },
  });
}

export const generatePresignedUrl = async (type, fileUrl) => {
  // If S3 client is not initialized, return the original URL
  if (!s3) {
    console.warn("AWS credentials not configured. Returning original URL.");
    return fileUrl;
  }

  try {
    // Extract key after ".com/"
    const key = fileUrl.split(".com/")[1];
    const bucket =
      type === "private"
        ? process.env.REACT_APP_AWS_PRIVATE_BUCKET_NAME
        : process.env.REACT_APP_AWS_BUCKET_NAME;

    if (!bucket) {
      console.warn("AWS bucket name not configured. Returning original URL.");
      return fileUrl;
    }

    console.log("key1",key)

    const command = new GetObjectCommand({
      Bucket: bucket,
      Key: key,
      ResponseContentDisposition: `attachment; filename="${fileUrl}"`,
    });
    const url = await getSignedUrl(s3, command, { expiresIn: 60 * 15 });
    return url;
  } catch (error) {
    console.error("Error generating presigned URL:", error);
    // Return original URL as fallback
    return fileUrl;
  }
};

export const generatePresignedUrl1 = async (type, fileUrl) => {
  if (!fileUrl) return fileUrl;

  try {
    const key = fileUrl.includes(".com/") ? fileUrl.split(".com/")[1] : fileUrl;
    if (!key) return fileUrl;

    const finalKey = key?.split("/").pop();
    const params = new URLSearchParams({ key: finalKey, type });
    const { data, response } = await get(
      `${api}/cloud/presigned-url?${params}`,
    );

    if (response === "Success" && data?.url) {
      return data?.url;
    }
    return fileUrl;
  } catch (error) {
    console.warn(
      "Presigned URL request failed, using original URL:",
      error?.message,
    );
    return fileUrl;
  }
};
